import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { SiteImobiliaria } from '@/integrations/supabase/types';
import { MOCK_SITE_CONFIG } from '@/data/mockData';

const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true';

/**
 * Hook para buscar configurações do site da imobiliária
 * @param imobiliariaId - ID da imobiliária
 */
export function useSiteConfig(imobiliariaId?: string) {
  return useQuery({
    queryKey: ['siteConfig', imobiliariaId],
    queryFn: async (): Promise<SiteImobiliaria> => {
      // Modo mock: retorna dados mockados imediatamente
      if (USE_MOCK_DATA) {
        return MOCK_SITE_CONFIG;
      }

      // Modo real: busca da view pública do HouseBit
      const { data, error } = await supabase
        .from('sites_imobiliarias_public')
        .select('*')
        .eq('imobiliaria_id', imobiliariaId!)
        .single();

      if (error) throw error;
      if (!data) throw new Error('Site não encontrado ou não está publicado');

      return data;
    },
    enabled: !!imobiliariaId,
    staleTime: 1000 * 60 * 5, // Cache por 5 minutos
  });
}
